import { TicketingFormCategory } from "../enums/ticketing";
const WEB_BASED_TICKET_CATEGORIES = [
    TicketingFormCategory.Event,
    TicketingFormCategory.Custom,
    TicketingFormCategory.Lottery,
    TicketingFormCategory.Sweepstakes,
];
export const isWebBasedTicketsEligible = ({ formCategory, generateQrCode, }) => {
    return WEB_BASED_TICKET_CATEGORIES.includes(formCategory) && Boolean(generateQrCode);
};
export const getTicketingThankYouPreviewTicketCtas = ({ formCategory, generateQrCode, webBasedTicketPlaceholderUrl, }) => {
    const hasQrCode = Boolean(generateQrCode);
    const isWebBased = isWebBasedTicketsEligible({
        formCategory: formCategory,
        generateQrCode,
    });
    return {
        webBasedEventTicketUrl: isWebBased ? webBasedTicketPlaceholderUrl : "",
        eTicketUrl: hasQrCode && !isWebBased ? undefined : "",
        hasWalletButtons: hasQrCode && formCategory !== TicketingFormCategory.Shop,
    };
};
